// extracted by mini-css-extract-plugin
module.exports = {"DownloadView":"DownloadView_DownloadView__2f7Jy","preview":"DownloadView_preview__1AXuk","dlButton":"DownloadView_dlButton__1Lz44"};